import type { StaticSharedField } from './types';
import {
  ERR_TYPE_REQUIRED,
  ERR_TYPE_STR_LONG,
  ERR_TYPE_STR_SHORT,
  FIELD_TYPE_TXT,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useSupplierId(): StaticSharedField {
  return {
    propName: 'supplier_id',
    element: 'supplier_id',
    type: FIELD_TYPE_TXT,
    label: 'Transport supplier ID:',
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNOSUPPLIERID',
        errStr: 'Please enter a valid name of identifier',
      },
      {
        rule: ERR_TYPE_STR_SHORT,
        errCode: 'ERRSUPPLIERIDTOOSHORT',
        errStr: 'Please enter a valid name of identifier',
        value: 3,
      },
      {
        rule: ERR_TYPE_STR_LONG,
        errCode: 'ERRSUPPLIERIDTOOLONG',
        errStr: 'Please enter a valid name of identifier',
        value: 300,
      },
    ],
  };
}
